export enum PlanStatusEnum {
    Completed = 'completed',
    Current = 'current',
    Locked = 'locked',
}
